import { render, staticRenderFns } from "./Kinds.vue?vue&type=template&id=7e9854ff&scoped=true"
import script from "./Kinds.vue?vue&type=script&lang=js"
export * from "./Kinds.vue?vue&type=script&lang=js"
import style0 from "./Kinds.vue?vue&type=style&index=0&id=7e9854ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9854ff",
  null
  
)

export default component.exports